import { Link, useParams } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import { blogPosts } from '../../../mocks/blogs';

export default function BlogDetailPage() {
  const { slug } = useParams<{ slug: string }>();
  const post = blogPosts.find((p) => p.slug === slug);

  if (!post) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">文章不存在</h1>
          <Link to="/blogs" className="text-pink-600 hover:text-pink-700">
            返回博客列表
          </Link>
        </div>
      </div>
    );
  }

  const relatedPosts = blogPosts.filter((p) => p.id !== post.id).slice(0, 3);

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* 面包屑導航 */}
      <div className="bg-gray-50 py-4 mt-32">
        <div className="max-w-4xl mx-auto px-4">
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <Link to="/" className="hover:text-gray-900">首頁</Link>
            <span>/</span>
            <Link to="/blogs" className="hover:text-gray-900">童裝資訊</Link>
            <span>/</span>
            <span className="text-gray-900 line-clamp-1">{post.title}</span>
          </div>
        </div>
      </div>

      {/* 文章內容 */}
      <article className="max-w-4xl mx-auto px-4 py-12">
        {/* 文章頭部 */}
        <div className="mb-8">
          <div className="flex items-center gap-4 mb-4">
            <span className="bg-pink-600 text-white px-4 py-1 rounded-full text-sm whitespace-nowrap">
              {post.category}
            </span>
            <div className="flex items-center gap-2 text-sm text-gray-500">
              <i className="ri-calendar-line"></i>
              <span>{post.date}</span>
            </div>
          </div>

          <h1 className="text-4xl font-bold text-gray-900 mb-6 leading-tight">
            {post.title}
          </h1>

          <p className="text-lg text-gray-600 leading-relaxed">
            {post.excerpt}
          </p>
        </div>

        {/* 特色圖片 */}
        <div className="relative w-full h-96 rounded-lg overflow-hidden mb-12">
          <img
            src={post.image}
            alt={post.title}
            className="w-full h-full object-cover object-top"
          />
        </div>

        {/* 文章正文 */}
        <div
          className="prose prose-lg max-w-none mb-12"
          dangerouslySetInnerHTML={{ __html: post.content }}
          style={{ fontSize: '16px', lineHeight: '1.8', color: '#374151' }}
        />

        {/* 標籤 */}
        <div className="flex flex-wrap gap-3 py-8 border-t border-b border-gray-200 mb-12">
          <span className="text-gray-700 font-medium">標籤：</span>
          {post.tags.map((tag, index) => (
            <span
              key={index}
              className="text-sm text-gray-600 bg-gray-100 px-3 py-1 rounded-full hover:bg-gray-200 transition-colors cursor-pointer"
            >
              #{tag}
            </span>
          ))}
        </div>

        {/* 分享按鈕 */}
        <div className="flex items-center gap-4 mb-16">
          <span className="text-gray-700 font-medium">分享：</span>
          <button className="w-10 h-10 flex items-center justify-center bg-gray-100 hover:bg-pink-600 hover:text-white rounded-full transition-colors cursor-pointer">
            <i className="ri-facebook-fill text-lg"></i>
          </button>
          <button className="w-10 h-10 flex items-center justify-center bg-gray-100 hover:bg-pink-600 hover:text-white rounded-full transition-colors cursor-pointer">
            <i className="ri-twitter-fill text-lg"></i>
          </button>
          <button className="w-10 h-10 flex items-center justify-center bg-gray-100 hover:bg-pink-600 hover:text-white rounded-full transition-colors cursor-pointer">
            <i className="ri-whatsapp-fill text-lg"></i>
          </button>
          <button className="w-10 h-10 flex items-center justify-center bg-gray-100 hover:bg-pink-600 hover:text-white rounded-full transition-colors cursor-pointer">
            <i className="ri-link text-lg"></i>
          </button>
        </div>

        {/* 相關文章 */}
        {relatedPosts.length > 0 && (
          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-8">相關文章</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {relatedPosts.map((relatedPost) => (
                <Link
                  key={relatedPost.id}
                  to={`/blogs/${relatedPost.slug}`}
                  className="group bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-lg transition-all cursor-pointer"
                >
                  <div className="relative w-full h-48 overflow-hidden">
                    <img
                      src={relatedPost.image}
                      alt={relatedPost.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                  <div className="p-4">
                    <h3 className="text-base font-bold text-gray-900 mb-2 line-clamp-2 group-hover:text-pink-600 transition-colors">
                      {relatedPost.title}
                    </h3>
                    <p className="text-sm text-gray-600 line-clamp-2">
                      {relatedPost.excerpt}
                    </p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        )}
      </article>

      {/* 返回列表按鈕 */}
      <div className="max-w-4xl mx-auto px-4 pb-20">
        <Link
          to="/blogs"
          className="inline-flex items-center gap-2 text-pink-600 hover:text-pink-700 font-medium cursor-pointer"
        >
          <i className="ri-arrow-left-line"></i>
          <span>返回博客列表</span>
        </Link>
      </div>

      <Footer />
    </div>
  );
}
